import ApplicationSerializer from "./application";
import ENV from "glesys-controlpanel/config/environment";

export default class EmailDomainSerializer extends ApplicationSerializer {
  usesProxy = true;

  primaryKey = "domainname";

  normalizeArrayResponse(store, primaryModelClass, payload, id, requestType) {
    let normalizedPayload = {
      domains: payload.response.overview.domains.map((domain) => {
        domain.project = payload.project;
        return domain;
      }),
      meta: payload.response.overview.meta,
    };

    return super.normalizeArrayResponse(store, primaryModelClass, normalizedPayload, id, requestType);
  }

  normalize(modelClass, resourceHash, prop) {
    // The names clashes with the relationships
    resourceHash.accountsCount = resourceHash.accounts;
    resourceHash.aliasesCount = resourceHash.aliases;
    delete resourceHash.accounts;
    delete resourceHash.aliases;

    resourceHash.links = {
      accounts: `${ENV.apiBaseUri}/email/list?domainname=${resourceHash.domainname}`,
      aliases: `${ENV.apiBaseUri}/email/list?domainname=${resourceHash.domainname}`,
    };

    return super.normalize(modelClass, resourceHash, prop);
  }
}
